// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r8m8","toggleWrap":"styles_toggleWrap__1uycD","content":"styles_content__3Orba","selectAreaCode":"styles_selectAreaCode__aGrcj"};